import curd from '../curd'

const BASE_PATH = '/user'

export default curd(BASE_PATH, {
  getMaxAuditStage: () => ({
    url: `${BASE_PATH}/audit/count`,
    method: 'GET'
  })
})



// WEBPACK FOOTER //
// ./src/apis/modules/User.js